import { render, staticRenderFns } from "./rsshAddEdit.vue?vue&type=template&id=2b336b1d"
import script from "./rsshAddEdit.vue?vue&type=script&lang=js"
export * from "./rsshAddEdit.vue?vue&type=script&lang=js"
import style0 from "./rsshAddEdit.vue?vue&type=style&index=0&id=2b336b1d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports